module.exports = __webpack_public_path__ + "static/media/stephaniealoe-IG.f3b8fa88.PNG";